import React from "react";
import "./url-parser.scss";

const UrlParser = (props) => {
  
  const isUrl = word => {
    const urlPattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;
    return word.match(urlPattern);
  }

  const AuxComponent = (p) => {
    const text = p.content;
    
    if (text.indexOf('<br>') > -1 ) return <br/>;

    if (isUrl(text)) {
      if (isYouTubeURL(text)) {
        return buildYTiframe(extractYouTubeVideoId(text));
      }
      else {
        return  (
          <a href={text} target="_blank">
            {text}&nbsp;
          </a>
        );
      }
    }

    return `${text} `;
  }

  const isYouTubeURL = (url) => {
    return url.includes('youtube.com') || url.includes('youtu.be');
  };

  const extractYouTubeVideoId = (url) => {
    const videoIdRegex = /(?:\/embed\/|\/watch\?v=|\/(?:embed\/|v\/|watch\?.*v=|youtu\.be\/|embed\/|v=))([^&?#]+)/;
    const match = url.match(videoIdRegex);
    return match ? match[1] : '';
  };

  const buildYTiframe = (embedId) => {
    return (
      <div className="yt-video-frame">
        <iframe
          width="320"
          height="180"
          src={`https://www.youtube.com/embed/${embedId}?modestbranding=1;controls=0;showinfo=0;rel=0;fs=1`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Embedded youtube"
        />
      </div>
    )
  }

  return (
    <AuxComponent content={props.value} />
  );
}

export default UrlParser;